import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../lib/net";

import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class PMS_Acs extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.avd = "01";
    this.state.aca = [];
    this.state.kro = {};
    this.state.aa = [];
    this.state.cols = {};
    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.fdat = dts;
    this.state.tdat = dts;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.acs();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }

  kund_open(row) {
      var self = this;
  }
  kund_edit(row) {
      var self = this;
      //alert(JSON.stringify(row.krr00));
        this.setState({edit: 1, kro: row});
  }
  fkn_close() {
    this.setState({edit: false });
    //this.props.history.push("cas");
    //this.login_srv(uid, pwd);
  }

  acs() {
    var self = this;
    var prm = {};
    prm.req = "pms.ac.ac_list";
    prm.fdat = "20200915";
    prm.tdat = "20200915";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({aca: ret.rco });
        self.syncCols("acsTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  cssCols = function (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols = function (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <div className="flex-row flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            FUNKTIONER
        </button>
        </div>
        <div className="flex-row">
              <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
              <Dt_Cal startdatum="2020-02-01" rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
              <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
              <Dt_Cal startdatum="2020-02-01" rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
              <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
        <div className="flex-row flex-end flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

    <div className="web-col">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.cssCols("c01" ) }>Start</th>
                <th style={ this.cssCols("c02" ) }>Slut</th>
                <th style={ this.cssCols("c03" ) }>Boknr</th>
                <th style={ this.cssCols("c04" ) }>Text</th>
                <th style={ this.cssCols("c05" ) }>Grupp</th>
                <th style={ this.cssCols("c06" ) }>Antal</th>
                <th style={ this.cssCols("c07" ) }>Lokal</th>
                <th style={ this.cssCols("c08" ) }>Status</th>
                <th style={ this.cssCols("c09" ) }>Signatur</th>
                <th style={ this.cssCols("c10" ) }></th>
                <th style={{width:"16px"}} ></th>
            </tr>
            </thead>
        </table>
       <div className="tb-cdi" style={ this.tb_style() }>
       <table id="acsTable" className="table table-bordered table-hover tb">
            <tbody>
            { this.state.aca.map((row, key) =>
            <tr key={key} id={ row.bokr00.start } onDoubleClick={() => this.kund_edit(row) }>
                <td>{ row.bokr00.start }</td>
                <td>{ row.bokr00.slut }</td>
                <td>{ row.bokr00.resno }</td>
                <td>{ row.bokr00.text }</td>
                <td>{ row.bokr00.resurs }</td>
                <td>{ row.bokr00.antal }</td>
                <td>{ row.bokr00.restyp }</td>
                <td>{ row.bokr00.status }</td>
                <td>{ row.bokr00.sign }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.kund_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            <tr style={{visibility: "hidden"}}>
                <th>Start</th>
                <th>Slut</th>
                <th>Boknr</th>
                <th>Text</th>
                <th>Grupp</th>
                <th>Antal</th>
                <th>Lokal</th>
                <th>Status</th>
                <th>Signatur</th>
                <th></th>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
   </div>
  );
    }
}
export default PMS_Acs;
